import ChangePageTitleSimple from "./ChangePageTitleSimple"
import OutsideClickComponent from "../../../fragments/OutsideClickComponent"
import TransitionContainer from "../../../common/TransitionContainer"
import Card from "../../../common/Card"
import { useNavigate, useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useState, useEffect } from "react"
import { retrieveAllWorkQs, retrieveAllWorkQsGrouped } from "../../../../lib/systemData"
import classes from '../ChangePage.module.css'
import { filterActions } from "../../../../store/filter"
import { workqueueActions } from "../../../../store/workqueue"
import WorkQsListWithChildren from "../WorkQsListWithChildren"


export default function ChangePageSimple() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const params = useParams()
    const [isListOpened, setIsListOpened] = useState(false)

    const [list, setList] = useState(null)
    useEffect(() => {
        // let workqLists = retrieveAllWorkQs()
        let workqLists = retrieveAllWorkQsGrouped()
        if (workqLists) {
            setList(workqLists)
        }
    }, [])  

    
    const openListHandler = () => {
        setIsListOpened(true)
    }

    const closeListHandler = () => {
        setIsListOpened(false)
    }

    const goToWorkQueue = (item) => {
        navigate(`/work-queues/${item.slug}`)
        dispatch(filterActions.setCurrentPage(1))
        dispatch(workqueueActions.setSelectedWorkQueue(item))
        setIsListOpened(false)

    }

    return <> 

        {list && <>
            <ChangePageTitleSimple openListHandler={openListHandler} isListOpened={isListOpened}/>
            {isListOpened && <OutsideClickComponent task={closeListHandler}>
                <div className={classes.page_list}>
                    <TransitionContainer>
                        <Card>
                            <div className={classes.page_list_inner}>
                                <WorkQsListWithChildren list={list} setIsListOpened={setIsListOpened} classes={classes}/>
                                {/* <ul>
                                    {list.map(group => (
                                        <li key={group.id} className={classes.group_item}>
                                            {group.workQs && <ul className={classes.inner_list}>
                                                {group.workQs.map(item => (
                                                    <li key={item.id} className={`${classes.inner_item} ${params?.workqSlug == item.slug ? classes.active_item : ''}`}>
                                                        <button onClick={() => goToWorkQueue(item)}>{item.name}</button>
                                                    </li>
                                                ))}
                                            </ul>}
                                        </li>
                                    ))} */}
                                    {/* {list.filter(item => item.parent_id == null).map(item => (
                                        <li key={item.slug} className={params?.workqSlug == item.slug ? classes.active_item : ''}>
                                            <button onClick={() => goToWorkQueue(item)}>
                                                {item.name}
                                                {list.filter(sub_item => sub_item.parent_id != null && sub_item.parent_id==item.id) && list.filter(sub_item => sub_item.parent_id != null && sub_item.parent_id==item.id).length > 0 && <i className="ti ti-chevron-right"></i>}
                                            </button>

                                            {list.filter(sub_item => sub_item.parent_id != null && sub_item.parent_id==item.id) && list.filter(sub_item => sub_item.parent_id != null && sub_item.parent_id==item.id).length > 0 && <ul className={classes.child_work_qs}>
                                                {list.filter(sub_item => sub_item.parent_id != null && sub_item.parent_id==item.id).map(item => (
                                                    <li key={item.slug} className={params?.workqSlug == item.slug ? classes.active_item : ''}>
                                                        <button onClick={() => goToWorkQueue(item)}>{item.name}</button>                                                        
                                                    </li>
                                                ))}
                                            </ul>}
                                        </li>
                                    ))} */}
                                {/* </ul> */}
                            </div>
                        </Card>
                    </TransitionContainer>
                </div> 
            </OutsideClickComponent>}
        </>}
    </>
}